module.exports = __webpack_public_path__ + "static/media/footui_10.6c59d42f.gif";